import type {
  AnchorHTMLAttributes,
  ReactNode
} from 'react';

import
  Link
from 'next/link';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS,
  PRIMARY_BUTTON_CLASSES
} from '@repo/brand';

interface PrimaryButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: ReactNode
  // Plain <a> instead of next/link's <Link> - for external hrefs (wa.me,
  // mailto:) where client-side prefetch/navigation doesn't apply anyway.
  external?: boolean
  // Full-width block layout (matches SecondaryButton's default shape) instead
  // of the default inline pill - used for card/list "Get started" CTAs.
  block?: boolean
}

// Solid-gradient pill CTA - the primary counterpart to SecondaryButton's
// outline style. className should supply padding/gap (px-*, py-*, gap-*),
// since those legitimately vary by CTA size across the site.
export default function PrimaryButton({
  href, children, className, external, block, ...props
}: PrimaryButtonProps) {

  const layout = block ? 'block text-center' : 'inline-flex items-center justify-center';

  const mergedClassName = className
    ? `${ layout } ${ PRIMARY_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS } ${ className }`
    : `${ layout } ${ PRIMARY_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS }`;

  const style = {
    background: BRAND_GRADIENT
  };

  if (external) {

    return (
      <a
        href={href}
        className={mergedClassName}
        style={style}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={href}
      className={mergedClassName}
      style={style}
      {...props}
    >
      {children}
    </Link>
  );
}
